import { ComputedBarDatum } from '@nivo/bar'
import { ErrorPoint } from './MostFrequentErrorsChart'
import ErrorBarItem from './ErrorBarItem'

type LayerProps = {
    interactive?: boolean;
    bars: ComputedBarDatum<ErrorPoint>[];
    mx: number;
}

function ErrorBarsLayer({ interactive, bars, mx }: LayerProps) {
    return (
        <g>
            {bars.map(({ width, height, y, data, color }) => (
                <ErrorBarItem 
                    key={data.data.trashType}
                    interactive={interactive}
                    width={width}
                    height={height}
                    y={y}
                    data={data.data}
                    color={color}
                    mx={mx}
                    />
            ))}
        </g>
    );
}

export default ErrorBarsLayer;